import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
const testimonials = [{
  quote: 'Organice toda mi ensalada mental en un solo fin de semana. Ahora sé exactamente qué hábito está disparando mi ansiedad y cómo cortarlo en 5 minutos. Nunca más volví a vivir el día improvisando o al borde del colapso.',
  author: 'Tomás M.',
  location: 'Buenos Aires'
}, {
  quote: 'El enfoque de disciplina emocional lo cambió todo. Logré frenar los bucles de pensamientos destructivos en menos de 2 meses, después de estar un año entero atrapado en rumiación constante. Dormir volvió a ser algo normal.',
  author: 'Ignacio R.',
  location: 'Rosario'
}, {
  quote: 'Adapto el plan de emergencia mental según cómo me siento en el día. Antes me pasaba horas buscando videos en YouTube o leyendo tips sueltos en Instagram para intentar calmarme sin éxito.',
  author: 'Valentina F.',
  location: 'Córdoba'
}];
export function Testimonials() {
  return <section className="py-24 md:py-32 px-6 bg-cream text-charcoal" data-id="element-174">
      <div className="max-w-6xl mx-auto" data-id="element-175">
        <FadeIn data-id="element-176">
          <h2 className="text-3xl md:text-5xl text-center mb-16 md:mb-24 max-w-2xl mx-auto leading-tight" data-id="element-177">
            Lo que dicen quienes ya{' '}
            <span className="italic text-terracotta" data-id="element-178">
              recuperaron el control
            </span>
          </h2>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-179">
          {testimonials.map((t, i) => <StaggerItem key={i} className="relative" data-id="element-180">
              <div className="absolute -top-10 -left-4 text-8xl font-serif text-charcoal/5 leading-none select-none" data-id="element-181">
                "
              </div>
              <div className="relative z-10 flex flex-col h-full" data-id="element-182">
                <p className="text-lg md:text-xl leading-relaxed italic mb-8 flex-grow" data-id="element-183">
                  "{t.quote}"
                </p>
                <div className="pt-6 border-t border-charcoal/10" data-id="element-184">
                  <p className="font-serif text-lg font-medium" data-id="element-185">{t.author}</p>
                  <p className="text-sm text-charcoal/60 uppercase tracking-widest mt-1" data-id="element-186">
                    {t.location}
                  </p>
                </div>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}